import moment from 'moment';

type TGenTimestampsParams = {
  numCycles: number; // how many total cycles to do
  strideWeeks: number; // how many weeks to put between each cycle
};

function genTimestamps(base: moment.Moment, tsParams?: TGenTimestampsParams) {
  const params = tsParams || { numCycles: 3, strideWeeks: 2 };
  const results = [base];
  for (let i = 0; i < params.numCycles; ++i) {
    results.push(genTimestampForWeek(base, params.strideWeeks * (i + 1)));
  }
  return results;
}

function genTimestampForWeek(base: moment.Moment, week: number) {
  return moment.utc(base).add(week, 'week');
}

export const mdiSpring2019Timestamps: any = {
  westTT: genTimestamps(moment.utc('2019-03-23T14:00:00Z')),
  westCup: genTimestamps(moment.utc('2019-03-23T15:00:00Z').add(1, 'week')),
  eastTT: genTimestamps(moment.utc('2019-03-29T23:00:00Z')),
  eastCup: genTimestamps(moment.utc('2019-03-30T00:00:00Z').add(1, 'week'))
};

export const mdiSummer2019Timestamps: any = {
  westTT: genTimestamps(moment.utc('2019-08-01T14:00:00Z')),
  westCup: genTimestamps(moment.utc('2019-08-10T15:00:00Z')),
  eastTT: genTimestamps(moment.utc('2019-08-07T23:00:00Z')),
  eastCup: genTimestamps(moment.utc('2019-08-17T02:00:00Z'))
};

export const keystoneMasters2020Timestamp = moment.utc('2020-03-03T14:00:00Z');
export const keystoneMastersFX2020Timestamp = moment.utc('2020-09-02T14:00:00Z');
export const keystoneBuildersSeason2Timestamps = {
  // real start time: 17:00, but taking leeway to allow change in slot time
  start: moment.utc('2021-12-03T16:00:00'),

  // real end time: 03:00, but taking leeway to allow change in slot time
  end: moment.utc('2021-12-06T07:00:00')
};

export const keystoneBuildersSeason3Timestamps = {
  start: moment.utc('2023-04-19T16:00:00'),

  end: moment.utc('2023-04-23T16:00:00')
};

export const eveAscension3QualifiersRegionalTimestamps = {
  na: { start: moment.utc('2023-08-29T15:00:00'), end: moment.utc('2023-09-12T15:00:00') },
  eu: { start: moment.utc('2023-08-30T04:00:00'), end: moment.utc('2023-09-13T04:00:00') },
  tw: { start: moment.utc('2023-08-30T23:00:00'), end: moment.utc('2023-09-13T23:00:00') },
  kr: { start: moment.utc('2023-08-30T23:00:00'), end: moment.utc('2023-09-13T23:00:00') }
};

export const keystoneBuildersSeason3FinalsTimestamps = {
  // First group runs at 10AM PT Friday April 28th
  start: moment.utc('2023-04-28T17:00:00'),
  // Last group should be finished by 2PM PT Sunday April 30th
  end: moment.utc('2023-04-30T21:00:00')
};

export const dreamMythicMasters2020Timestamps = {
  start: moment.utc('2020-07-23T10:00:00Z'),
  end: moment.utc('2020-07-26T18:00:00Z')
};

export const mdiBfa2020Timestamps: any = {
  eastTT: genTimestamps(moment.utc('2020-04-02T14:00:00Z')),
  eastCup: genTimestamps(moment.utc('2020-04-11T17:00:00Z')),
  westTT: genTimestamps(moment.utc('2020-04-09T17:00:00Z')),
  westCup: genTimestamps(moment.utc('2020-04-18T17:00:00Z'))
};

export const mdiBfa2020Config = {
  currentTrial: {
    name: 'AMER Time Trials #3',
    slug: 'amer-3'
  },
  currentBracket: {
    name: 'Global Finals',
    slug: 'global-finals',
    dayVideos: [
      {
        type: 'youtube',
        videoId: 'YOS--XOjDvk',
        label: 'Day 3',
        starts: moment.utc('2020-07-12T17:00:00Z').subtract(30, 'minutes')
      },
      {
        type: 'youtube',
        videoId: '2K_dhZwUajw',
        label: 'Day 2',
        starts: moment.utc('2020-07-11T17:00:00Z').subtract(30, 'minutes')
      },
      {
        type: 'youtube',
        videoId: 'GYDYtdKtavU',
        label: 'Day 1',
        starts: moment.utc('2020-07-10T17:00:00Z').subtract(30, 'minutes')
      }
    ]
  }
};

//
// Shadowlands
//
const SL1_CHINA_TT_BASE = moment.utc('2021-01-15T02:00:00Z');
const SL1_CHINA_CUP_BASE = moment.utc('2021-01-22T08:00:00Z');
const SL1_CHINA_FINALS_BASE = moment.utc('2021-03-26T18:00:00Z');

const SL1_GLOBAL_TT_BASE = moment.utc('2021-01-14T18:00:00Z');
// Starting at MDI Global TT #3 they reduced to 4 days from 5 days
const SL1_GLOBAL_TT_BASE_SHIFTED = moment.utc('2021-01-15T18:00:00Z');
const SL1_GLOBAL_CUP_BASE = moment.utc('2021-01-22T18:00:00Z');
const SL1_GLOBAL_FINALS_BASE = moment.utc('2021-04-23T18:00:00Z');

const SL1_GREATPUSH_QUALIFIERS = moment.utc('2021-05-22T04:00:00Z');
const SL1_GREATPUSH_TOURNAMENT = moment.utc('2021-05-28T17:00:00Z');

export const mdiSL1Timestamps: any = {
  chinaTT: [
    genTimestampForWeek(SL1_CHINA_TT_BASE, 0),
    genTimestampForWeek(SL1_CHINA_TT_BASE, 2),
    genTimestampForWeek(SL1_CHINA_TT_BASE, 7)
  ],
  chinaCup: [
    genTimestampForWeek(SL1_CHINA_CUP_BASE, 0),
    genTimestampForWeek(SL1_CHINA_CUP_BASE, 2),
    genTimestampForWeek(SL1_CHINA_CUP_BASE, 7)
  ],
  globalTT: [
    genTimestampForWeek(SL1_GLOBAL_TT_BASE, 0),
    genTimestampForWeek(SL1_GLOBAL_TT_BASE, 2),
    genTimestampForWeek(SL1_GLOBAL_TT_BASE_SHIFTED, 5),
    genTimestampForWeek(SL1_GLOBAL_TT_BASE_SHIFTED, 7)
  ],
  globalCup: [
    genTimestampForWeek(SL1_GLOBAL_CUP_BASE, 0),
    genTimestampForWeek(SL1_GLOBAL_CUP_BASE, 2),
    genTimestampForWeek(SL1_GLOBAL_CUP_BASE, 5),
    genTimestampForWeek(SL1_GLOBAL_CUP_BASE, 7)
  ],
  globalFinals: [genTimestampForWeek(SL1_GLOBAL_FINALS_BASE, 0)],
  chinaFinals: [genTimestampForWeek(SL1_CHINA_FINALS_BASE, 0)],
  greatPush: [genTimestampForWeek(SL1_GREATPUSH_QUALIFIERS, 0), genTimestampForWeek(SL1_GREATPUSH_TOURNAMENT, 0)]
};

export const mdiSL1Config = {
  currentTrial: {
    name: 'Global Time Trials #4',
    slug: 'global-4'
  },
  currentTimeTrialWeeks: {
    global: 4,
    china: 3
  },
  currentCupWeeks: {
    global: 4,
    china: 3
  },
  currentBracket: {
    name: 'Global Finals',
    slug: 'global-finals',
    dayVideos: [
      {
        type: 'youtube',
        videoId: 'XcZU0uq75n8',
        label: 'Day 3',
        starts: moment.utc('2021-04-25T18:00:00Z').subtract(30, 'minutes')
      },
      {
        type: 'youtube',
        videoId: '9OSqCaOioTs',
        label: 'Day 2',
        starts: moment.utc('2021-04-24T18:00:00Z').subtract(30, 'minutes')
      },
      {
        type: 'youtube',
        videoId: 'rge0Xg7U6Lc',
        label: 'Day 1',
        starts: moment.utc('2021-04-23T18:00:00Z').subtract(30, 'minutes')
      }
    ]
  }
};

export const mdiGreatPushConfig = {
  currentBracket: {
    name: 'The Great Push Season 2',
    slug: 'shadowlands-season-2',
    dayVideos: [
      {
        type: 'youtube',
        videoId: 'VO50qCRAERU',
        label: 'Day 3',
        starts: moment.utc('2021-12-12T18:00:00Z').subtract(30, 'minutes')
      },
      {
        type: 'youtube',
        videoId: 'suRN_1wvou8',
        label: 'Day 2',
        starts: moment.utc('2021-12-11T18:00:00Z').subtract(30, 'minutes')
      },
      {
        type: 'youtube',
        videoId: 'kWCdm8K9oF0',
        label: 'Day 1',
        starts: moment.utc('2021-12-10T18:00:00Z').subtract(30, 'minutes')
      }
    ]
  }
};

const SL2_GLOBAL_TT_BASE = moment.utc('2021-08-18T17:00:00Z');
const SL2_CHINA_TT_BASE = moment.utc('2021-08-19T10:00:00Z');
const SL2_LAST_STAND_TT_BASE = moment.utc('2021-09-24T17:00:00Z');

const SL2_GREAT_PUSH_TT_BASE = moment.utc('2021-12-03T18:00:00Z');
const SL2_GREAT_PUSH_TOURNAMENT_BASE = moment.utc('2021-12-10T18:00:00Z');

export const mdiSL2Timestamps: any = {
  globalTT: [genTimestampForWeek(SL2_GLOBAL_TT_BASE, 0)],
  chinaTT: [genTimestampForWeek(SL2_CHINA_TT_BASE, 0)],
  lastStandTT: [genTimestampForWeek(SL2_LAST_STAND_TT_BASE, 0), genTimestampForWeek(SL2_LAST_STAND_TT_BASE, 1)],
  greatPushTT: [genTimestampForWeek(SL2_GREAT_PUSH_TT_BASE, 0)],
  greatPushTournament: [genTimestampForWeek(SL2_GREAT_PUSH_TOURNAMENT_BASE, 0)]
};

export const mdiSL2Config = {
  currentTrial: {
    name: 'The Last Stand',
    slug: 'last-stand-tournament'
  },
  currentBracket: {
    name: 'Season Finals',
    slug: 'season-finals',
    dayVideos: [
      {
        type: 'youtube',
        videoId: '_wwFUofS1zk',
        label: 'Day 3',
        starts: moment.utc('2021-10-31T17:00:00Z').subtract(30, 'minutes')
      },
      {
        type: 'youtube',
        videoId: '5Gq58e-PpD4',
        label: 'Day 2',
        starts: moment.utc('2021-10-30T17:00:00Z').subtract(30, 'minutes')
      },
      {
        type: 'youtube',
        videoId: 'ks5yUmDQR3Y',
        label: 'Day 1',
        starts: moment.utc('2021-10-29T17:00:00Z').subtract(30, 'minutes')
      }
    ]
  }
};

const SL3_GLOBAL_TT_BASE = moment.utc('2022-04-06T17:00:00Z');
const SL3_CHINA_TT_BASE = moment.utc('2022-04-07T10:00:00Z');
const SL3_LAST_STAND_TT_BASE = moment.utc('2022-05-13T17:00:00Z');

export const mdiSL3Timestamps: any = {
  globalTT: [genTimestampForWeek(SL3_GLOBAL_TT_BASE, 0)],
  chinaTT: [genTimestampForWeek(SL3_CHINA_TT_BASE, 0)],
  lastStandTT: [genTimestampForWeek(SL3_LAST_STAND_TT_BASE, 0), genTimestampForWeek(SL3_LAST_STAND_TT_BASE, 1)]
};

export const mdiSL3Config = {
  currentTrial: {
    name: 'The Last Stand',
    slug: 'last-stand-qualifiers'
  },
  currentBracket: {
    name: 'The Last Stand',
    slug: 'last-stand-tournament',
    dayVideos: [
      {
        type: 'youtube',
        videoId: 'D2odxCgIfIc',
        label: 'Day 3',
        starts: moment.utc('2022-05-22T17:00:00Z').subtract(30, 'minutes')
      },
      {
        type: 'youtube',
        videoId: 'cb0duq5rCc0',
        label: 'Day 2',
        starts: moment.utc('2022-05-21T17:00:00Z').subtract(30, 'minutes')
      },
      {
        type: 'youtube',
        videoId: 'jYMTTq_UQc4',
        label: 'Day 1',
        starts: moment.utc('2022-05-20T17:00:00Z').subtract(30, 'minutes')
      }
    ]
  }
};

const SL4_GREAT_PUSH_PROVING_GROUNDS_BASE = moment.utc('2022-08-10T17:00:00Z');
const SL4_GREAT_PUSH_REGIONALS_BASE = moment.utc('2022-08-19T17:00:00Z');
const SL4_GREAT_PUSH_CN_REGIONALS = moment.utc('2022-08-26T10:00:00Z');
const SL4_GREAT_PUSH_FINALS_BASE = moment.utc('2022-09-02T17:00:00Z');

export const mdiSL4Timestamps: any = {
  greatPushProvingGrounds: [genTimestampForWeek(SL4_GREAT_PUSH_PROVING_GROUNDS_BASE, 0)],
  greatPushRegionalsAMER: [genTimestampForWeek(SL4_GREAT_PUSH_REGIONALS_BASE, 0)],
  greatPushRegionalsEMEA: [genTimestampForWeek(SL4_GREAT_PUSH_REGIONALS_BASE, 1)],
  greatPushRegionalsCHINA: [genTimestampForWeek(SL4_GREAT_PUSH_CN_REGIONALS, 0)],
  greatPushFinals: [genTimestampForWeek(SL4_GREAT_PUSH_FINALS_BASE, 0)]
};

export const mdiSL4EventIds: any = {
  provingGrounds: {
    amer: 10065,
    emea: 10066,
    china: 10067
  },
  regionals: {
    amer: 10068,
    emea: 10069,
    china: 10070,
    'grand-finals': 10071
  }
};

export const mdiDF2EventIds: any = {
  provingGrounds: 10081,
  group: {
    'group-a': 10083,
    'group-b': 10084,
    'group-c': 10085,
    'global-finals': 10082
  }
};

export const mdiSL4Config = {
  currentTrial: {
    name: 'The Last Stand',
    slug: 'last-stand-tournament'
  },
  currentBracket: {
    name: 'Global Finals',
    slug: 'grand-finals',
    dayVideos: [
      {
        type: 'youtube',
        videoId: 'uvd6mxSaZ9s',
        label: 'Day 3',
        starts: moment.utc('2022-09-04T17:00:00Z').subtract(30, 'minutes')
      },
      {
        type: 'youtube',
        videoId: 'vF1lxk22Ek8',
        label: 'Day 2',
        starts: moment.utc('2022-09-03T17:00:00Z').subtract(30, 'minutes')
      },
      {
        type: 'youtube',
        videoId: 'F3slOEr22CA',
        label: 'Day 1',
        starts: moment.utc('2022-09-02T17:00:00Z').subtract(30, 'minutes')
      }
    ]
  }
};

//
// Armed Forces Dungeon Clash
//
const AFDC_TOURNAMENT_START = moment.utc('2022-07-15T17:00:00');
const AFDC_TOURNAMENT_END = moment.utc('2022-07-15T17:00:00').add(3, 'days').add(8, 'hours');

export const afdc2022Timestamps: any = {
  start: AFDC_TOURNAMENT_START,
  end: AFDC_TOURNAMENT_END
};

const AFDC_SL_SEASON4_TOURNAMENT_START = moment.utc('2022-10-14T17:00:00');
const AFDC_SL_SEASON4_TOURNAMENT_END = moment.utc('2022-10-14T17:00:00').add(3, 'days').add(8, 'hours');

export const afdc2022Season4Timestamps: any = {
  start: AFDC_SL_SEASON4_TOURNAMENT_START,
  end: AFDC_SL_SEASON4_TOURNAMENT_END
};

//
// Charity Pro Am 2022
//

const CHARITY_PRO_AM_2022_TOURNAMENT_START = moment.utc('2022-07-30T16:30:00');

export const charityProAm2022Timestamps: any = {
  start: CHARITY_PRO_AM_2022_TOURNAMENT_START,

  end: moment.utc(CHARITY_PRO_AM_2022_TOURNAMENT_START).add(7, 'hours')
};

const CHARITY_PRO_AM_2023_TOURNAMENT_START = moment.utc('2023-04-15T16:00:00');

export const charityProAm2023Timestamps: any = {
  start: CHARITY_PRO_AM_2023_TOURNAMENT_START,

  end: moment.utc(CHARITY_PRO_AM_2023_TOURNAMENT_START).add(7, 'hours')
};

const LWIW_EVE_ASCENSION_2023_TOURNAMENT_START = moment.utc('2023-04-22T16:00:00');
export const lwiwEveAscension2023TimeStamps: any = {
  start: LWIW_EVE_ASCENSION_2023_TOURNAMENT_START,

  end: moment.utc(LWIW_EVE_ASCENSION_2023_TOURNAMENT_START).add(6, 'hours')
};

const LWIW_EVE_ASCENSION_DF_2_TOURNAMENT_START = moment.utc('2023-09-30T16:00:00');
export const lwiwEveAscensionDfS2TimeStamps: any = {
  start: LWIW_EVE_ASCENSION_DF_2_TOURNAMENT_START,

  end: moment.utc(LWIW_EVE_ASCENSION_DF_2_TOURNAMENT_START).add(7, 'hours')
};

const DF1_GLOBAL_TT_BASE = moment.utc('2023-02-01T21:00:00Z');
const DF1_GROUP_STAGE_BASE = moment.utc('2023-02-17T18:00:00Z');
const DF1_FINALS_BASE = moment.utc('2023-03-31T17:00:00Z');
const DF1_LAST_STAND_TT_BASE = moment.utc('2023-03-06T17:00:00Z');
const DF1_LAST_STAND_TOURNAMENT_BASE = moment.utc('2023-03-10T18:00:00Z');

export const mdiDF1Timestamps: any = {
  globalTT: [genTimestampForWeek(DF1_GLOBAL_TT_BASE, 0)],
  lastStandTT: [genTimestampForWeek(DF1_LAST_STAND_TT_BASE, 0), genTimestampForWeek(DF1_LAST_STAND_TOURNAMENT_BASE, 0)],
  groupStage: [genTimestampForWeek(DF1_GROUP_STAGE_BASE, 0), genTimestampForWeek(DF1_GROUP_STAGE_BASE, 1)],
  finals: [genTimestampForWeek(DF1_FINALS_BASE, 0)]
};

export const mdiDF1Config = {
  currentTrial: {
    name: 'Time Trials',
    slug: 'global'
  },
  currentBracket: {
    name: 'Season Finals',
    slug: 'finals',
    dayVideos: [
      {
        type: 'youtube',
        videoId: 'PikpK_Wf0-4',
        label: 'Day 3',
        starts: moment.utc('2023-04-02T18:00:00Z').subtract(30, 'minutes')
      },
      {
        type: 'youtube',
        videoId: '9bXFMC-YGrA',
        label: 'Day 2',
        starts: moment.utc('2023-04-01T18:00:00Z').subtract(30, 'minutes')
      },
      {
        type: 'youtube',
        videoId: 'A8gxz-Q6uuo',
        label: 'Day 1',
        starts: moment.utc('2023-03-31T18:00:00Z').subtract(30, 'minutes')
      }
    ]
  }
};

const DF2_GLOBAL_TT_BASE = moment.utc('2023-07-05T17:00:00Z');
const DF2_FINALS_BASE = moment.utc('2023-08-18T17:00:00Z');
const DF2_GROUP_A = moment.utc('2023-07-21T17:00:00Z');
const DF2_GROUP_B = moment.utc('2023-07-28T17:00:00Z');
const DF2_GROUP_C = moment.utc('2023-08-04T17:00:00Z');

type BracketSchedule = {
  starts: moment.Moment;
  ends: moment.Moment;
};

type ScheduleConfig = {
  [key: string]: BracketSchedule;
};

type CurrentBracket = {
  name: string;
  slug: string;
};

type MDIDF2Config = {
  currentBracket: CurrentBracket;
  schedule: ScheduleConfig;
};

export const mdiDF2Timestamps: Record<string, moment.Moment[]> = {
  greatPushProvingGrounds: [genTimestampForWeek(DF2_GLOBAL_TT_BASE, 0)],
  greatPushFinals: [genTimestampForWeek(DF2_FINALS_BASE, 0)],
  greatPushGroupA: [genTimestampForWeek(DF2_GROUP_A, 0)],
  greatPushGroupB: [genTimestampForWeek(DF2_GROUP_B, 0)],
  greatPushGroupC: [genTimestampForWeek(DF2_GROUP_C, 0)]
};

export const mdiDF2Config: MDIDF2Config = {
  currentBracket: {
    name: 'Global Finals',
    slug: 'global-finals'
  },
  schedule: {
    'group-a': {
      starts: mdiDF2Timestamps.greatPushGroupA[0],
      ends: moment(mdiDF2Timestamps.greatPushGroupA[0]).add(3, 'days')
    },
    'group-b': {
      starts: mdiDF2Timestamps.greatPushGroupB[0],
      ends: moment(mdiDF2Timestamps.greatPushGroupB[0]).add(3, 'days')
    },
    'group-c': {
      starts: mdiDF2Timestamps.greatPushGroupC[0],
      ends: moment(mdiDF2Timestamps.greatPushGroupC[0]).add(3, 'days')
    },
    'global-finals': {
      starts: mdiDF2Timestamps.greatPushFinals[0],
      ends: moment(mdiDF2Timestamps.greatPushFinals[0]).add(3, 'days')
    }
  }
};

export const dungeonDojoSeason1Timestamps = {
  eu: {
    start: moment.utc('2023-02-23T14:00:00'),
    end: moment.utc('2023-02-24T00:00:00')
  },
  na: {
    start: moment.utc('2023-02-23T20:00:00'),
    end: moment.utc('2023-02-24T06:00:00')
  }
};
